import script from "./UserReviewsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserReviewsListView.vue?vue&type=script&setup=true&lang=js"

import "./UserReviewsListView.vue?vue&type=style&index=0&id=7b797e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b797e7a"]])

export default __exports__